import { aR, aspectRatios } from '../global-constants';

export const getPlacement = (aspectRatio) => {
	return aspectRatios.get(aspectRatio);
};

export const getCouponStatus = (aspectRatio) => {
	return (
		aspectRatio === aR.DESKTOP_4X3 || aspectRatio === aR.MOBILE_4X3_COUPON   || aspectRatio === aR.MOBILE_4X3_SLIDESHOW
	);
};

export const isMobile4x3 = (aspectRatio) => {
	return (
		aspectRatio === aR.MOBILE_4X3_SLIDESHOW ||
		aspectRatio === aR.MOBILE_4X3_COUPON
	);
};

export const getCouponCaroDisplay = (width) => {
	return width + 48 > 992 ? 3 : 2;
};
